import React from 'react'
export default function Skills({ skills, lang, t }) {
  return (
    <section className="section soft" id="skills">
      <div className="container">
        <p className="eyebrow">{t.skills}</p>
        <div className="skills-grid">
          {skills[lang].map(([title, items]) => (
            <div className="skill-card" key={title}>
              <h3>{title}</h3>
              <div>
                {items.map((x) => (
                  <span key={x}>{x}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
